import React from 'react';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();
  const userEmail = localStorage.getItem('userEmail');

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('userEmail');
    navigate('/login');
  };

  if (!localStorage.getItem('isLoggedIn')) {
    return <div className="pt-32 text-center text-white text-2xl font-bold">Brak dostępu. Zaloguj się!</div>;
  }

  return (
    <div className="min-h-screen bg-[#0f172a] pt-32 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white/5 border border-white/10 p-8 rounded-3xl backdrop-blur-xl">
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-3xl font-black text-white">Witaj, <span className="text-cyan-400">{userEmail}</span>! 👋</h1>
            <button onClick={handleLogout} className="bg-red-500/20 text-red-400 px-6 py-2 rounded-xl border border-red-500/20 hover:bg-red-500 hover:text-white transition">Wyloguj</button>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-black/20 p-6 rounded-2xl border border-white/5">
              <p className="text-gray-400 text-sm mb-1">Aktywne Usługi</p>
              <p className="text-2xl font-bold text-white">0</p>
            </div>
            <div className="bg-black/20 p-6 rounded-2xl border border-white/5">
              <p className="text-gray-400 text-sm mb-1">Stan portfela</p>
              <p className="text-2xl font-bold text-green-400">0.00 PLN</p>
            </div>
            <div className="bg-black/20 p-6 rounded-2xl border border-white/5">
              <p className="text-gray-400 text-sm mb-1">Twoje IP</p>
              <p className="text-2xl font-bold text-cyan-400">Pobieranie...</p>
            </div>
          </div>
          
          <div className="mt-12 p-20 border-2 border-dashed border-white/5 rounded-3xl text-center">
            <p className="text-gray-500 font-medium text-lg">Nie masz jeszcze żadnych aktywnych serwerów.</p>
            <button className="mt-4 text-cyan-400 font-bold hover:underline">Zamów swoją pierwszą usługę &rarr;</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;